module.exports = __webpack_public_path__ + "static/media/mang1.a4fb997d.avif";